import React, {useState} from 'react';
import CKEditor from "../CKEditor/CKEditor";
import {PromptDialog} from "../Dialog/Message";

export const TemplateZero = ({
                               buttonComp,
                               resetTemplateHandler,
                               displayEditContentButton,
                               publishActiveTemplate,
                               canCustomize,
                               props
                             }) => {
  const [show, setShow] = useState(false);
  const [showPublish, setShowPublish] = useState(false);
  const promptResetTemplate = () => {
    setShow(true);
  }
  return (
    <>
      <div className="row">
        <div className={`col-md-3 col-sm-12 img_92k`}>
          <CKEditor type="left" {...props} />
        </div>
        <div className={`col-md-6 col-sm-12`}>
          <div className={'row'}>
            <div className={`col-md-12 col-sm-12`}>
              <CKEditor type="topMid" height="330px" {...props} />
            </div>
            <div className={`col-md-12 col-sm-12 center_btn`}>
              {canCustomize &&
                <button className="resetBtn btn btn-primary btn-lg" type={"button"} style={{ 'float': 'left' }}
                        onClick={() => setShowPublish(true)}>Publish Template
                </button>
              }
              {displayEditContentButton &&
                <button className="resetBtn btn btn-primary btn-lg" type={"button"} style={{ 'float': 'left', 'marginLeft': '10px' }}
                          onClick={() => promptResetTemplate()}>Reset Original Template
                  </button>
              }
              {!canCustomize && buttonComp}
            </div>
          </div>
        </div>
        <div className={`col-md-3 col-sm-12 img_92k`}>
          <CKEditor type="right" {...props} />
        </div>
      </div>
      {
        show &&
        <PromptDialog
          onRef={(ref) => {
          }}
          onlyDialog={true}
          title={"Reset Template"}
          body={"This will reset content and images you have uploaded to default content. Are you sure you`d like to reset template?"}
          okText={"Yes"}
          cancelText={"No"}
          onOk={() => {resetTemplateHandler();setShow(false);}}
          onCancel={() => setShow(false)}
          show={show}
        />
      }
      {
        showPublish &&
        <PromptDialog
          onRef={(ref) => {
          }}
          onlyDialog={true}
          title={"Publish Template"}
          body={"The published template will be displayed to all prospects who click on your unique 9 to Know Link."}
          okText={"Yes"}
          cancelText={"No"}
          onOk={() => {publishActiveTemplate(); setShowPublish(false);}}
          onCancel={() => setShowPublish(false)}
          show={showPublish}
        />
      }
    </>
  )
}
